<template>
  <div class="dashboard-stats-grid mb-8">
    <StatsCard
      title="Chiffre d'affaires du mois"
      :value="stats.chiffreAffaires"
      suffix="€"
      icon="fas fa-euro-sign"
      icon-color="text-green-600"
      icon-bg-color="bg-green-100"
      :change="stats.chiffreAffairesChange"
      :clickable="false"
      :is-loading="props.isLoading"
    />
    
    <StatsCard
      title="Commandes du mois"
      :value="stats.totalCommandes"
      icon="fas fa-shopping-cart"
      icon-color="text-blue-600"
      icon-bg-color="bg-blue-100"
      :change="stats.commandesChange"
      :is-loading="props.isLoading"
      action-label="Voir les commandes"
      @click="openStatsModal('commandes')"
      @action="openStatsModal('commandes')"
    />
    
    <StatsCard
      title="Commandes en attente"
      :value="stats.commandesEnAttente"
      icon="fas fa-clock"
      icon-color="text-yellow-600"
      icon-bg-color="bg-yellow-100"
      :change="stats.enAttenteChange"
      :is-loading="props.isLoading"
      action-label="Voir les commandes en attente"
      @click="openStatsModal('enAttente')"
      @action="openStatsModal('enAttente')"
    />
    
    <StatsCard
      title="Total des produits"
      :value="stats.totalProduits"
      icon="fas fa-box"
      icon-color="text-purple-600"
      icon-bg-color="bg-purple-100"
      :is-loading="props.isLoading"
      action-label="Voir les produits"
      @click="navigateToProductList"
      @action="navigateToProductList"
    />

    <StatsCard
      title="Acheteurs en panier"
      :value="acheteursEnPanier"
      icon="fas fa-shopping-basket"
      icon-color="text-orange-600"
      icon-bg-color="bg-orange-100"
      :is-loading="isLoadingPaniers"
      action-label="Voir le détail"
      @click="emit('open-paniers')"
      @action="emit('open-paniers')"
    />
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { StatsCard } from '@/components'
import type { DashboardStats } from '@/types'

interface Props {
  stats: DashboardStats
  isLoading?: boolean
  isLoadingPaniers?: boolean
  acheteursEnPanier?: number
  openStatsModal: (type: string) => void
}

const props = withDefaults(defineProps<Props>(), {
  isLoading: false,
  isLoadingPaniers: false,
  acheteursEnPanier: 0,
})

const emit = defineEmits<{
  'open-paniers': []
}>()

const router = useRouter()

const navigateToProductList = () => {
  router.push({ name: 'catalog/productlist' })
}
</script>

<style scoped>
.dashboard-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 16rem), 1fr));
  gap: 1.5rem;
}
</style>
